import * as React from 'react'

import { Box, Button, Icon, Table, Text } from '@factorialco/deprecated-design-system'
import { TimesheetEditTimesheetRequestFragment } from 'generated/resources/graphql'

import TextField from 'modules/core/components/TextField'

import PendingRequestTag from 'modules/attendance/components/ClockIn/Shifts/HourlyShifts/HourlyTable/DayRow/ShiftPanelTableBody/PendingRequestTag'

interface PendingCreateRequestRowProps {
  background: 'champagne100' | 'grey100' | 'grey000White'
  request: TimesheetEditTimesheetRequestFragment
}

const PendingCreateRequestRow = ({ background, request }: PendingCreateRequestRowProps) => {
  return (
    <Table.Row background={background}>
      <Table.Cell colSpan={2} wide noBorder>
        <Box flexDirection="row" alignItems="center" gap="s8" paddingLeft="s32">
          <Box gap="s8">
            <Box flexDirection="row">
              <Box flexDirection="row" alignItems="center" height="s48">
                <Box maxWidth="s96">
                  <TextField placeholder="--:--" readonly />
                </Box>
                <Box padding="s6">
                  <Text.Normal color="grey600">–</Text.Normal>
                </Box>
                <Box maxWidth="s96">
                  <TextField placeholder="--:--" readonly />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box flexDirection="row" alignItems="center" gap="s8" height="s48" minWidth="s24">
            <Button type="secondary" iconName="pencil" disabled />
            <Button type="secondary" iconName="delete" disabled />
            <Box padding="s4">
              <Icon.Medium icon="history" color="grey600" />
            </Box>
            <Box padding="s4">
              <Icon.Medium icon="comment" color="grey600" />
            </Box>
          </Box>
        </Box>
      </Table.Cell>
      <Table.Cell wide noBorder colSpan={4}>
        <Box>
          <PendingRequestTag request={request} key={request.id} />
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default PendingCreateRequestRow
